import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const handleClick = (props) => {
    if (!props.disabled) {
        props.onChange(!props.checked);
    }
};
const getCheckbox = (props) => {
    var _a;
    return (React.createElement("div", { id: `${props.dataTestId}-inner-input`, className: `custom-checkbox-container ${props.disabled ? 'disabled' : ''}`, "data-testid": props.extraDataTestIdOnInput, onClick: () => handleClick(props) },
        React.createElement("div", { className: "custom-checkbox" }, props.checked && React.createElement(SVGIcon, { icon: SVGIcons.CHECKBOX_CHECKED })),
        React.createElement("div", { className: "label" }, props.skipTranslation
            ? props.title
            : getMessage((_a = props.title) !== null && _a !== void 0 ? _a : ''))));
};
const CheckboxComponent = (props) => {
    if (!props.tooltipMessage) {
        return getCheckbox(props);
    }
    else
        return (React.createElement(CustomTooltip, { position: 'top', message: props.tooltipMessage, skipTranslation: props.skipTooltipTranslation }, getCheckbox(props)));
};
export default CheckboxComponent;
